import "./ZipcodeHeatmap.css";
import InputSection from "../components/InputSection";
import { useState, useEffect, useRef } from "react";
import LTlogo from "../public/img/LT_logo.svg";
import { useNavigate } from "react-router-dom";
import config from "../config";

function Heatmap() {
  const [apiData, setApiData] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 630);
  const [showMobileInputs, setShowMobileInputs] = useState(false);
  const navigate = useNavigate();
  const default_url = `${config.api.baseUrl}/heatmap/result/default.html`;
  const currentHeatmapIframeRef = useRef(null);

  const handleApiData = (data) => {
    setApiData(data);
    if (isMobile) {
      setShowMobileInputs(false);
    }
  };

  const apiDataChange = () => {
    if (!currentHeatmapIframeRef.current) return;
    currentHeatmapIframeRef.current.style.zIndex = -2;
    currentHeatmapIframeRef.current.src = "";
  };

  useEffect(() => {
    if (!currentHeatmapIframeRef.current) return;
    if (apiData !== null && apiData !== "") {
      currentHeatmapIframeRef.current.style.zIndex = 0;
      currentHeatmapIframeRef.current.src = apiData;
    } else {
      currentHeatmapIframeRef.current.style.zIndex = -2;
      currentHeatmapIframeRef.current.src = "";
    }
  }, [apiData]);

  useEffect(() => {
    const onResize = () => {
      const isNowMobile = window.innerWidth <= 630;
      setIsMobile(isNowMobile);
      if (!isNowMobile) {
        setShowMobileInputs(false);
      }
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div
      className={`heatmap-page ${
        isMobile && showMobileInputs ? "inputs-active" : "map-active"
      }`}
    >
      {isMobile && (
        <div className="heatmap-mobile-switcher">
          <button
            className={`heatmap-mobile-switch-btn ${
              !showMobileInputs ? "active" : ""
            }`}
            onClick={() => setShowMobileInputs(false)}
          >
            Map
          </button>
          <button
            className={`heatmap-mobile-switch-btn ${
              showMobileInputs ? "active" : ""
            }`}
            onClick={() => setShowMobileInputs(true)}
          >
            Inputs
          </button>
        </div>
      )}
      <InputSection
        onApiDataReceived={handleApiData}
        onApiDataChange={apiDataChange}
        className="side-menu"
        hideTab={isMobile}
        forcedExpanded={isMobile ? showMobileInputs : null}
        onExpandedChange={(expanded) => {
          if (isMobile) {
            setShowMobileInputs(expanded);
          }
        }}
      />
      <div className="lt-logo-heatmap">
        <img
          src={LTlogo}
          alt="logo"
          onClick={(e) => {
            navigate("/");
          }}
        />
      </div>
      <iframe
        src={default_url}
        id="heatmap-iframe"
        title="Default zipcode heatmap"
        width="100%"
      ></iframe>
      <iframe
        ref={currentHeatmapIframeRef}
        src={null}
        id="current-heatmap"
        title="Current zipcode heatmap"
        width="100%"
      ></iframe>
    </div>
  );
}

export default Heatmap;
